import {customElement} from "solid-element";
import {setTranslations, translations} from "../../services/context";
import {getTranslations} from "../../services/translation";
import { Show, createSignal, For, createEffect, onMount } from "solid-js";

document.addEventListener("DOMContentLoaded", function(event) {
    let baTagElement = document.querySelector('*[data-tag*="ba-ai-prompt"]');
    if(baTagElement){
        getTranslations(configBaTemplatesList.lang || 'en').then(r => setTranslations(r))
        let webcomponent = document.createElement('builderall-ai-prompt');
        baTagElement.insertAdjacentElement('afterend', webcomponent);
        baTagElement.remove();
    }
});

customElement("builderall-ai-prompt", props => {
    const [promptValue, setPromptValue] = createSignal('');

    function submitPrompt() {
        localStorage.setItem('ai-prompt', promptValue())
        const customEvent = new CustomEvent("ai-prompt-submit", {
            detail: { prompt: promptValue()},
        });
        document.dispatchEvent(customEvent);
    }

    return (
        <>
            <style>{require("bundle-text:./styles/index.scss")}</style>
            <div class="ai-prompt-container">
                <div class="ai-prompt">
                    <textarea 
                        class='ba-textarea' 
                        name='prompt'
                        id='prompt'
                        cols='30'
                        rows='5'
                        maxLength={500}
                        placeholder={translations['appshell-ai-prompt-placeholder']}
                        value={promptValue()}
                        onInput={e => setPromptValue(e.target.value)}
                    ></textarea>
                    <button class="ai-button" disabled={promptValue() == ''} onClick={() => submitPrompt()}>
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.214 0.213135C10.9531 0.213135 10.692 0.314491 10.4932 0.513794L10.4056 0.601403C10.007 1.00001 10.007 1.64539 10.4056 2.04297L14.344 5.98141H1.01945C0.456715 5.98141 0 6.43812 0 7.00086C0 7.5636 0.456715 8.02031 1.01945 8.02031H14.344L10.4056 11.9587C10.007 12.3574 10.007 13.0027 10.4056 13.4003L10.4932 13.4879C10.8918 13.8865 11.5372 13.8865 11.9348 13.4879L17.701 7.72164C18.0997 7.32304 18.0997 6.67766 17.701 6.28007L11.9348 0.513794C11.7355 0.314491 11.4748 0.213135 11.214 0.213135Z" fill="white"/>
                        </svg>
                    </button>
                </div>
            </div>
        </>
    );
});